module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Настроено автоматическое приглашение кандидатов","text":"Вы настроили автоматическое приглашение кандидатов, поэтому кандидатам будет отправляться приглашение на интервью сразу после того, как они откликнутся на вакансию на job-сайте.","text2":"Если вы хотите самостоятельно выбирать, кому отправлять приглашения, вы можете изменить это в {0}","settings":"настройках"}}')
  delete Component.options._Ctor
}
